import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Form as BootstrapForm } from "react-bootstrap";
import formatCnpj from "@brazilian-utils/format-cnpj";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

import {
  Textfield,
  NextButton,
  ErrorMessage,
  Label,
} from "./styles";
import api from "~/services/api";

function Document(props) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const SignUpSchema = Yup.object().shape({
    erpCode: Yup.string().required("Preencha o Código do Cliente"),
    document: Yup.string()
      .required("Preencha seu CNPJ")
      .min(18, "Informe um CNPJ válido"),
  });

  function handleErpCode(e, handleChange) {
    const event = e;
    const numbers = event.target.value.replace(/[^\d]/g, "");
    event.target.value = event.target.value.replace(/[^\d]/g, "");
    if (numbers.length === 30) {
      event.target.value = numbers;
    }
    return handleChange(event);
  }

  function handleDocument(e, handleChange) {
    const event = e;
    const numbers = event.target.value.replace(/[^\d]/g, "");
    event.target.value = event.target.value.replace(/[^\d]/g, "");

    event.target.value = formatCnpj(numbers);
    return handleChange(event);
  }

  function handleSubmit(values) {
    const header = {
      "Content-Type": "application/json",
      "Accept-Language": "pt-BR",
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    const body = {
      storeCode: `${values.erpCode}`,
      storeDocument: `${values.document
        .split(".")
        .join("")
        .split("/")
        .join("")
        .split("-")
        .join("")}`,
    };
    api
      .post("residential/store/v1/users/first-access-registration", body, parameters)
      .then((res) => {
        const firstAccessToken = res.data.firstAccessToken;
        const userId = res.data.userId;
        const emails = res.data.emails || [];
        const phones = res.data.phones || [];
        const files = res.data.files || {};
        const location = `residential/store/v1/users/${userId}`;

        dispatch({
          type: "ADD_LOCATION",
          location: location,
        });
        dispatch({
          type: "ADD_FIRST_ACCESS_TOKEN",
          firstAccessToken: firstAccessToken,
        });
        dispatch({
          type: "ADD_FILES",
          files: files,
        });
        localStorage.setItem("userId", userId);

        if (emails.length === 0 && phones.length === 0) {
          dispatch({ type: "STEP", step: 7 });
        } else if (emails.length > 0) {
          dispatch({
            type: "ADD_EMAILSLIST",
            emailsList: emails,
          });
          dispatch({ type: "STEP", step: 2 });
        } else {
          dispatch({
            type: "ADD_PHONESLIST",
            phonesList: phones,
          });
          dispatch({ type: "STEP", step: 3 });
        }
        setLoading(false);
      })
      .catch((err) => {
        if (err.response.status === 422) {
          toast.error("Código do cliente e documento não são correspondentes");
        } else if (err.response.status === 400) {
          toast.error("O campo de CNPJ está incorreto");
        }
        setLoading(false);
      });
  }

  return (
    <Formik
      initialValues={{ document: "", erpCode: "" }}
      onSubmit={(values) => {
        setLoading(true);
        handleSubmit(values);
      }}
      validationSchema={SignUpSchema}
    >
      {({ handleChange, handleBlur, values, errors, touched }) => (
        <Form style={{width: '100%'}} autocomplete="off">
          <BootstrapForm.Group controlId="erpCode">
            <Label>Código do Cliente</Label>
            <Field
              render={() => {
                return (
                  <Textfield
                    id="erpCode"
                    type="text"
                    label="Código do Cliente"
                    arial-label="Código do Cliente"
                    aria-required
                    errorCondition={errors.erpCode && touched.erpCode}
                    errorMessage={errors.erpCode}
                    title="Código do Cliente"
                    onBlur={handleBlur}
                    placeholder="Código do Cliente"
                    value={values.erpCode}
                    onChange={(e) => handleErpCode(e, handleChange)}
                  />
                );
              }}
              name="erpCode"
            />
            {errors.erpCode && touched.erpCode ? (
              <ErrorMessage>{errors.erpCode}</ErrorMessage>
            ) : null}
          </BootstrapForm.Group>
          <BootstrapForm.Group controlId="document">
            <Label>CNPJ</Label>
            <Field
              render={() => {
                return (
                  <Textfield
                    id="document"
                    type="text"
                    label="CNPJ"
                    arial-label="Seu CNPJ"
                    aria-required
                    errorCondition={errors.document && touched.document}
                    errorMessage={errors.document}
                    title="Seu CNPJ"
                    onBlur={handleBlur}
                    placeholder="Seu CNPJ"
                    value={values.document}
                    onChange={(e) => handleDocument(e, handleChange)}
                  />
                );
              }}
              name="document"
            />
            {errors.document && touched.document ? (
              <ErrorMessage>{errors.document}</ErrorMessage>
            ) : null}
          </BootstrapForm.Group>
          <NextButton type="submit" disabled={loading}>
            {loading ? (
              <i
                className="fa fa-spinner fa-pulse fa-3x fa-fw"
                style={{ fontSize: "1.3rem" }}
              />
            ) : (
              <span>Avançar</span>
           )}
          </NextButton>
        </Form>
      )}
    </Formik>
  );
}

export default Document;
